import React from "react";
import PropTypes from "prop-types";
import styles from "styles/modules/notification.module.scss";

const AppealChangeFailureNote = ({ field, fields }) => (
    <div className={styles.appealChangesFailureNote}>
        <i className="icon-error" />
        <span>{field}</span>
        {fields &&
            Array.isArray(fields) &&
            fields.map((field, index) => (
                <div key={index} className="field-with-extra-margin">
                    {field}
                </div>
            ))}
    </div>
);

AppealChangeFailureNote.propTypes = {
    field: PropTypes.string,
};

export default AppealChangeFailureNote;
